<template>
  <div>
    <assess-report :IsDetails="IsDetails" ref="assessReport" />

    <div v-if="!IsDetails" style="text-align: right; margin: 30px 0; padding-right: 50px">
      <a-button @click="$parent.$data.current = 0" style="margin-right: 20px">上一步 修改报告信息</a-button>
      <a-button :loading="nextLoading" type="primary" @click="next">下一步 筛选用户</a-button>
    </div>
  </div>
</template>

<script>
import AssessReport from '../../components/AssessReport'
import ContrastReport from '../../components/ContrastReport'
import $Bus from '@/pages/projectImpl/js/eventBus'

export default {
  name: 'StepsSecond',
  props: {
    IsDetails: false,
  },
  components: {
    ContrastReport,
    AssessReport,
  },
  data() {
    return {
      boxSpinning: false,
      nextLoading: false,
      reportType: this.$store.getters['organization/getReportInfo'].reportType,
      contrastReportChildrenLength: 0,
      reportInfo: this.$store.getters['organization/getReportInfo'],
    }
  },
  mounted() {
    $Bus.$on('contrastReportChildrenLength', (index) => {
      if (index) {
        this.contrastReportChildrenLength += index
      }
    })
  },
  methods: {
    next() {
      this.$message.destroy()
      if (!this.$refs.assessReport.$data.collapseList.length) {
        this.$message.error('请添加课程！')
        return
      }
      const paramsArr = []
      const tableData = this.$refs.assessReport.$data.collapseList.filter((f) => f.childTableData.length)
      console.log(tableData)

      if (tableData.length) {
        this.nextLoading = true
        for (let i = 0; i < tableData.length; i++) {
          let obj = {}
          for (let j = 0; j < tableData[i].childTableData.length; j++) {
            const item = tableData[i].childTableData[j]
            if (!obj[item.projectCourseChildId]) {
              obj[item.projectCourseChildId] = []
            }
            obj[item.projectCourseChildId] = obj[item.projectCourseChildId].concat(item.abilityDetails.filter((f) => f.scoreSwitch).map((m) => m.abilityId))
          }
          const contentAbilityConfigs = []
          for (let objKey in obj) {
            contentAbilityConfigs.push({
              organizationCourseSessionId: +objKey,
              contentAbilityIds: obj[objKey],
            })
          }
          paramsArr.push({
            organizationCourseId: tableData[i].organizationCourseId,
            combinationReportId: this.reportInfo.id,
            contentAbilityConfigs: contentAbilityConfigs,
          })
        }
        this.scoreSwitchEdit(paramsArr)
      } else {
        this.$parent.$data.current = 2
      }
    },
    scoreSwitchEdit(params) {
      this.$http.GroupReport.scoreSwitchEdit(params).then((res) => {
        this.generateReport();
      }).finally(()=>{
        this.nextLoading = false

      })
    },
    generateReport() {
      this.$http.GroupReport.generateReport({
        id:this.reportInfo.id
      }).then((res) => {
        this.nextLoading = false
        this.$parent.$data.current = 2
      })
    },
  },
}
</script>

<style scoped></style>
